/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-distracting-elements */
import React, { useEffect, useRef, useState } from 'react';
import { GetSession } from 'session-manager-beta';
import BlurLoader from '../CommonComponents/BlurFullPageLoader';
import { NotificationSound } from '../CommonComponents/CommonNotification';
import { ApiCall, convertToNumber } from '../CommonComponents/CustomHooks';
import { InputBox } from '../CommonComponents/InputBox';

const DownloadProcess = () => {
    const inputrefs = useRef([])
    const [timer, setTimer] = useState(0)
    const [subLoading, setSubLoading] = useState(false)
    const [ShowOtpInput, setShowOtpInput] = useState(false)
    const [Response, setResponse] = useState(false)
    const [isDisabled, setIsDisabled] = useState(false)
    const [isDOB, setIsDOB] = useState(false)

    let buttonText = GetSession('localStorage', 'buttonValue')
    let ClientCode = GetSession('localStorage', 'ClientCode')
    let EventCode = GetSession('localStorage', 'EventCode')
    let Token = GetSession('localStorage', 'Token')
    const canvasRef = useRef(null);

    const [captchaData, setCaptchaData] = useState({
        captcha: '',
        captchaInput: ''
    });
    const [clientLogo, setClientLogo] = useState('');
    const [clientBanner, setClientBanner] = useState('');
    const [helpLineNo, setHelpLineNo] = useState('');
    const [note, setNote] = useState('');
    const [hText, setHText] = useState('');
    const [helpDeskEmailID, setHelpDeskEmailID] = useState('');
    const [heText, setHeText] = useState('');
    const [formData, setFormData] = useState({
        mobileNo: "",
        emailID: "",
        isOTPRequired: true,
        isOTPRequiredEmail: true,
        isAllowCaptcha: false,
        otp: ''
    })
    const generateCaptchaText = () => {
        const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz23456789';
        let text = '';

        for (let i = 0; i < 6; i++) {
            text += chars.charAt(Math.floor(Math.random() * chars.length));
        }

        return text;
    };
    const drawCaptcha = (text) => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');

        ctx.clearRect(0, 0, canvas.width, canvas.height);

        // Gradient background
        const gradient = ctx.createLinearGradient(0, 0, canvas.width, canvas.height);
        gradient.addColorStop(0, '#f2f2f2');
        gradient.addColorStop(1, '#d6d6d6');
        ctx.fillStyle = gradient;
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        const colors = ['#000', '#1f7a1f', '#d11a2a', '#2c3e50', '#8e44ad'];

        for (let i = 0; i < text.length; i++) {
            const angle = (Math.random() - 0.5) * 0.6; // rotation

            ctx.save();
            ctx.font = `${22 + Math.random() * 8}px Arial`;
            ctx.fillStyle = colors[Math.floor(Math.random() * colors.length)];

            const x = 20 + i * 30;
            const y = 30 + Math.random() * 5;

            ctx.translate(x, y);
            ctx.rotate(angle);
            ctx.fillText(text[i], 0, 0);
            ctx.restore();
        }

        // Noise lines
        for (let i = 0; i < 3; i++) {
            ctx.strokeStyle = '#888';
            ctx.beginPath();
            ctx.moveTo(Math.random() * canvas.width, Math.random() * canvas.height);
            ctx.lineTo(Math.random() * canvas.width, Math.random() * canvas.height);
            ctx.stroke();
        }

        // Noise dots
        for (let i = 0; i < 40; i++) {
            ctx.fillStyle = '#999';
            ctx.beginPath();
            ctx.arc(Math.random() * canvas.width, Math.random() * canvas.height, 1, 0, Math.PI * 2);
            ctx.fill();
        }
    };
    useEffect(() => {
        if (formData.isAllowCaptcha) {
            const text = generateCaptchaText();
            setCaptchaData({ captcha: text, captchaInput: '' });
        }
    }, [formData.isAllowCaptcha]);
    const handleSendOtp = async () => {
        try {
            if (formData.isAllowCaptcha) {
                if (captchaData.captchaInput === "") {
                    NotificationSound('ERROR', 'Please enter Captcha', 'txtCaptcha', inputrefs);

                    const text = generateCaptchaText();
                    setCaptchaData({ captcha: text, captchaInput: '' });
                    drawCaptcha(text);

                    return;
                }
                else if (captchaData.captchaInput !== captchaData.captcha) {
                    NotificationSound('ERROR', 'Invalid CAPTCHA', 'txtCaptcha', inputrefs);

                    const text = generateCaptchaText();
                    setCaptchaData({ captcha: text, captchaInput: '' });
                    drawCaptcha(text);

                    return;
                }
            }
            await setFormData({ ...formData, otp: '' })
            await setSubLoading(true)
            let data = await ApiCall(`/api/EventProcess/SendOTP`, { ...formData, EventCode, ClientCode, Token });
            await setSubLoading(false)
            await setResponse(data)
            if (data.status === 'SUCCESS') {
                await setTimer(30);
                await setIsDisabled(true);
                await setShowOtpInput(true);
                await inputrefs.current['txtOTP'].focus()
            } else if (data.status === 'ERROR') {
                await setShowOtpInput(false)
                await NotificationSound(data.status, data.message, data.focus, inputrefs);
            }
        } catch (error) {
            console.error('Error sending OTP:', error);
        } finally {
            setSubLoading(false)
        }
    };
    useEffect(() => {
        if (captchaData.captcha && canvasRef.current) {
            drawCaptcha(captchaData.captcha);
        }
    }, [captchaData.captcha]);
    function ViewAndDownload(base64Data, fileName) {
        const byteCharacters = atob(base64Data);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(blob);
        window.open(fileURL);
    }

    function downloadFile1(url, fileName) {
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = fileName || 'download.pdf';
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
    }

    const handleDownload = async () => {
        try {
            if (formData.isAllowCaptcha) {
                if (captchaData.captchaInput === "") {
                    NotificationSound('ERROR', 'Please enter Captcha', 'txtCaptcha', inputrefs);

                    const text = generateCaptchaText();
                    setCaptchaData({ captcha: text, captchaInput: '' });
                    drawCaptcha(text);

                    return;
                }
                else if (captchaData.captchaInput !== captchaData.captcha) {
                    NotificationSound('ERROR', 'Invalid CAPTCHA', 'txtCaptcha', inputrefs);

                    const text = generateCaptchaText();
                    setCaptchaData({ captcha: text, captchaInput: '' });
                    drawCaptcha(text);

                    return;
                }
            }
            await setSubLoading(true)
            let data = await ApiCall(`/api/EventProcess/DownloadPrint`, { ...formData, EventCode, ClientCode, Token, isDOB });
            await setSubLoading(false)
            if (data.status === 'SUCCESS') {
                let fileName = data?.fileName || 'download.pdf';
                await ViewAndDownload(data.printUrl, fileName);
                await setFormData({
                    ...formData,
                    mobileNo: "",
                    emailID: "",
                    otp: ''
                })
                await setIsDisabled(false)
                await setResponse(false)
                await setShowOtpInput(false)
                await setTimer(0)
            } else if (data.status === 'ERROR') {
                await NotificationSound(data.status, data.message, data.focus, inputrefs);
            }
        } catch (error) {
            console.error('Error sending OTP:', error);
        } finally {
            await setSubLoading(false)
        }
    }

    const handleGetClientLogo = async (Type) => {
        try {
            await setSubLoading(true)
            let data = await ApiCall(`/api/EventProcess/GetClientLogo`, { EventCode, ClientCode, Type, Token });
            await setSubLoading(false)
            if (data.status === 'SUCCESS') {
                if (Type === 'ClientLogo') {
                    setClientLogo(data.clientLogo);
                    setClientBanner(data.clientBanner);
                    setFormData({ ...formData, isOTPRequired: data.isOTPRequired, isOTPRequiredEmail: data.isOTPRequiredEmail, isAllowCaptcha: data.isAllowCaptcha })
                    console.log(formData.isAllowCaptcha, "isAllowCaptcha");
                }
                else {
                    setHelpLineNo(data.helpLineNo);
                    setNote(data.note);
                    setHText(data.hText);
                    setHelpDeskEmailID(data.helpDeskEmailID)
                    setHeText(data.heText)
                }
            }
        } catch (error) {
            console.error('Error GetClientLogo:', error);
        } finally {
            await setSubLoading(false)
        }
    }

    useEffect(() => {
        document.title = 'Download Process';
        if (!ShowOtpInput) {
            handleGetClientLogo("ClientLogo");
            handleGetClientLogo("HelpLineNo");
        }
        let interval;
        if (timer > 0) {
            interval = setInterval(() => {
                setTimer(prev => prev - 1);
            }, 1000);
        } else if (timer === 0 && isDisabled) {
            setIsDisabled(false);
        }
        return () => clearInterval(interval);
    }, [timer, isDisabled]);

    useEffect(() => {
        if (EventCode === "E1062") {
            setIsDOB(true);
        }
    }, [EventCode])

    return (
        <>
            {subLoading &&
                <BlurLoader />}
            <section className="detail-form">
                <div className="container">
                    <div className="d-flex align-items-center justify-content-center">
                        <div className="col-lg-10">
                            <div className="police-st">
                               
                                {/*<div className=" d-flex justify-content-center">*/}
                                {/*    <span>*/}
                                {/*        <img*/}

                                {/*            src={clientLogo ? clientLogo : ''}*/}
                                {/*            alt=""*/}
                                {/*            className="img-fluid"*/}
                                {/*        />*/}
                                {/*    </span>*/}
                                {/*    <Link className="navbar-brand" to="/OnlineManagementSystem">*/}
                                {/*        <img*/}

                                {/*            src={clientBanner ? clientBanner : ''}*/}
                                {/*            className="img-fluid"*/}
                                {/*        />*/}
                                {/*    </Link>*/}
                                {/*</div>*/}
                                <div className="details-form details-form-mrg">
                                    <div className="row">
                                        <p className='text-center text-danger fw-semibold mb-3'
                                            style={{
                                                background: 'linear-gradient(90deg, #fff3f3, #ffe6e6)',
                                                border: '1px solid #ff4d4f',
                                                borderRadius: '8px',
                                                color: '#b30000',
                                               // fontWeight: '500',
                                                lineHeight: '1.6'
                                            }}>
                                            {note === "" ? "" : note}
                                        </p>
                                       
                                        <p className='text-center fs-4 fw-bold text-dark m-1 mb-3'>
                                            {buttonText}
                                        </p>
                                        <div className="col-lg-12 col-md-12 col-sm-12">
                                            <div className="mt-1">
                                                <div className="row">
                                                    <label className="col-md-4 col-form-label">
                                                        {!isDOB ? "Please Enter your Mobile No" : "Please Enter Serial No"}
                                                    </label>
                                                    <InputBox
                                                        id="txtMobileNo"
                                                        placeholder={!isDOB ? "Mobile No" : "Serial No"}
                                                        divclassname="col-md-8 mb-2"
                                                        inputclassname="downloadForm"
                                                        disabled={!isDOB ? !formData.isOTPRequired ? formData.emailID : false : false}
                                                        maxLength='10'
                                                        value={formData.mobileNo}
                                                        onChange={(e) => {
                                                            const newMobileNo = convertToNumber(e.target.value);
                                                            setFormData({ ...formData, mobileNo: newMobileNo });
                                                        }}
                                                        inputrefs={inputrefs}
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') {
                                                                inputrefs.current['txtEmailID'].focus()
                                                            }
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="mt-1">
                                                <div className="row">
                                                    <label className="col-md-4 col-form-label">
                                                        {!isDOB ? "Please Enter your Email ID" : "Please Enter your DOB"}
                                                    </label>
                                                    <InputBox
                                                        type={!isDOB ? "text" : "date"}
                                                        format={!isDOB ? "" : "dd-MMM-yyyy"}
                                                        id="txtEmailID"
                                                        placeholder={!isDOB ? "Email ID" : "Date of Birth"}
                                                        divclassname="col-md-8 mb-2"
                                                        inputclassname="downloadForm"
                                                        maxLength='50'
                                                        value={formData.emailID}
                                                        //disabled={!formData.isOTPRequiredEmail && formData.isOTPRequired !== formData.isOTPRequiredEmail}
                                                        disabled={!isDOB ? !formData.isOTPRequiredEmail ? formData.mobileNo : false : false}
                                                        onChange={(e) => {
                                                            const newEmailID = e.target.value;
                                                            console.log(newEmailID)
                                                            setFormData({ ...formData, emailID: newEmailID });
                                                        }}
                                                        inputrefs={inputrefs}
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') {
                                                                if (formData.isAllowCaptcha) {
                                                                    inputrefs.current['txtCaptcha']?.focus();
                                                                }
                                                                else if (!formData.isAllowCaptcha && formData.isOTPRequired) {
                                                                    handleSendOtp()
                                                                } else {
                                                                    inputrefs.current['txtClientName']?.focus();
                                                                }
                                                            }
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            {formData.isAllowCaptcha && (
                                                <div className="mt-3">
                                                    <div className="row">
                                                        <label className="col-md-4 col-form-label">
                                                            Enter CAPTCHA
                                                        </label>

                                                        <div className="col-md-8 d-flex align-items-center gap-2">
                                                            <canvas ref={canvasRef} width={200} height={45} />

                                                            <i
                                                                className="fa fa-refresh"
                                                                style={{ cursor: 'pointer' }}
                                                                onClick={() => {
                                                                    const text = generateCaptchaText();
                                                                    setCaptchaData({ captcha: text, captchaInput: '' });
                                                                    drawCaptcha(text);
                                                                }}
                                                            />
                                                        </div>

                                                        <InputBox
                                                            id="txtCaptcha"
                                                            placeholder="Enter CAPTCHA"
                                                            divclassname="col-md-8 offset-md-4 mt-2"
                                                            inputclassname="downloadForm"
                                                            value={captchaData.captchaInput}
                                                            onChange={(e) =>
                                                                setCaptchaData({ ...captchaData, captchaInput: e.target.value })
                                                            }
                                                            inputrefs={inputrefs}
                                                        />
                                                    </div>
                                                </div>
                                            )}
                                            {
                                                (formData.isOTPRequired || formData.isOTPRequiredEmail) && (
                                                    <div className="mt-2">
                                                        <div className="row">
                                                            <div className="col-md-12 col-sm-12 col-xs-12 d-flex align-items-center gap-2 justify-content-end">
                                                                {ShowOtpInput && <>
                                                                    <span style={{ color: 'var(--text)' }}>
                                                                        Didn't receive an OTP?
                                                                        <button
                                                                            type="button"
                                                                            onClick={handleSendOtp}
                                                                            id='btnSub'
                                                                            ref={ref => (inputrefs.current['btnSub'] = ref)}
                                                                            style={{
                                                                                background: 'none',
                                                                                border: 'none',
                                                                                color: '#007bff',
                                                                                fontWeight: 'bold',
                                                                                cursor: isDisabled ? 'not-allowed' : 'pointer',
                                                                                marginLeft: '7px',
                                                                                opacity: isDisabled ? 0.5 : 1,
                                                                            }}
                                                                            disabled={isDisabled}
                                                                        >
                                                                            {isDisabled ? `Resend (${timer}s)` : 'Resend'}
                                                                        </button>
                                                                    </span>
                                                                </>}

                                                                <button
                                                                    className="printbutton btn"
                                                                    type="button"
                                                                    id="btnOTP"
                                                                    disabled={isDisabled}
                                                                    onClick={handleSendOtp}
                                                                    style={{ color: "black" }}
                                                                >
                                                                    <i className="fa fa-send-o" /> Get OTP
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            }

                                            {
                                                (!formData.isOTPRequired && !formData.isOTPRequiredEmail) && (<div className="mt-2">
                                                    <div className="row">
                                                        <div className="col-md-12 col-sm-12 col-xs-12">
                                                            <button
                                                                className="printbutton btn"
                                                                type="button"
                                                                id="btnPrint"
                                                                onClick={handleDownload}
                                                                style={{ color: "black" }}
                                                            >
                                                                <i className="fa fa-print" /> {buttonText}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>)
                                            }

                                            {ShowOtpInput && <>
                                                <div className="mt-3">
                                                    <div className="row">
                                                        <label className="col-md-4 col-form-label">
                                                            Please Enter 6 digit OTP <span className="required">*</span>
                                                        </label>
                                                        <InputBox
                                                            id="txtOTP"
                                                            placeholder="OTP"
                                                            divclassname="col-md-8 mb-2"
                                                            inputclassname="downloadForm"
                                                            maxLength='6'
                                                            value={formData.otp}
                                                            onChange={(e) => setFormData({ ...formData, otp: convertToNumber(e.target.value) })}
                                                            inputrefs={inputrefs}
                                                            onKeyDown={(e) => {
                                                                if (e.key === 'Enter') {
                                                                    inputrefs.current['txtEmailID'].focus()
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="mt-2">
                                                    <div className="row">
                                                        <div className="col-md-12 col-sm-12 col-xs-12 text-center mb-2">
                                                            {isDisabled &&
                                                                <label className={'text-success fw-bold fs-6'}>{Response.message}</label>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="mt-2">
                                                    <div className="row">
                                                        <div className="col-md-12 col-sm-12 col-xs-12">
                                                            <button
                                                                className="printbutton btn"
                                                                type="button"
                                                                id="btnPrint"
                                                                onClick={handleDownload}
                                                                style={{ color: "black" }}
                                                            >
                                                                <i className="fa fa-print" /> {buttonText}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                            }

                                            <div className="mt-4">
                                                <div className="row">
                                                    <div
                                                        className="col-md-12 col-sm-12 col-xs-12 lblError"
                                                        style={{ borderRadius: 5 }}
                                                    >
                                                        <div
                                                            style={{ height: 46, backgroundColor: "#1055ae" }}
                                                            className="lblError text-center pt-1 mt-4 fs-4 text-light"
                                                        >
                                                            {helpLineNo === "" ? "" : hText + " : " + helpLineNo} 
                                                        </div>
                                                        <div
                                                            style={{ height: 46, backgroundColor: "#1055ae" }}
                                                            className="lblError text-center pt-1 mt-4 fs-4 text-light"
                                                        >
                                                            {helpDeskEmailID === "" ? "" : heText + " : " + helpDeskEmailID}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
export default DownloadProcess;